import { render, staticRenderFns } from "./Equation.vue?vue&type=template&id=6d1867d2&"
import script from "./Equation.vue?vue&type=script&lang=ts&"
export * from "./Equation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Equation.vue"
export default component.exports